// Generated by genversion.
module.exports = '5.5.6'
